import { SELECT_MAX_ITEMS } from 'Constants/index'
import debounce from 'lodash.debounce'
import { useMemo, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'

import {
  Flex,
  Grid,
  GridCell,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  Text,
  useAsyncSelect
} from 'mailup-web-components'

import {
  fetchGroups,
  getGroupById
} from 'Pages/Campaign/recoil/actions/asyncSelectActions'
import { onSelectErrorCallback } from 'Pages/Campaign/recoil/callbacks/callbacks'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'

const IncludeGroups = () => {
  const intl = useIntl()

  // async select
  const onError = useRecoilCallback(onSelectErrorCallback, [])
  const [{ EmailOptions }, setEmailOptions] = useRecoilState(campaignState)

  const getInitialItems = () => fetchGroups('')
  const getItemsByTerm = (searchTerm) => fetchGroups(searchTerm)
  const getItemById = (searchId) => getGroupById(searchId)

  const maxItems = SELECT_MAX_ITEMS

  const hints = {
    loading: intl.formatMessage({ id: 'Load.MailupCommon.InputStatusLoading' }),
    moreResults: intl.formatMessage({
      id: 'Load.Filters.ActivityMessagesMoreResults'
    }),
    noResults: intl.formatMessage({
      id: 'Load.MailupCommon.InputStatusNoMatches'
    })
  }

  const { onSearch, onChange, options, ...props } = useAsyncSelect({
    initialValue: EmailOptions.IncludeGroups || [],
    getInitialItems,
    getItemsByTerm,
    getItemById,
    onError,
    hints,
    maxItems
  })

  const withNoGroup = useMemo(() => {
    const label = intl.formatMessage({
      id: 'Load.SearchRecipients.nessunGruppo'
    })
    return [
      {
        value: 0,
        label
      },
      ...options
    ]
  }, [options])

  const handleChange = (v) => {
    onChange(v)
    setEmailOptions((prev) => ({
      ...prev,
      EmailOptions: {
        ...prev.EmailOptions,
        IncludeGroups: v,
        ExcludeGroups:
          prev.EmailOptions.ExcludeGroups &&
          prev.EmailOptions.ExcludeGroups.length > 0
            ? prev.EmailOptions.ExcludeGroups.filter((e) => !v.includes(e))
            : prev.EmailOptions.ExcludeGroups
      },
      isDirty: true
    }))
  }

  const { current: debouncedOnSearch } = useRef(debounce(onSearch, 350))

  const handleSearch = (s) => {
    debouncedOnSearch.cancel()
    debouncedOnSearch(s)
    return s
  }

  return (
    <>
      <Grid cols={12}>
        <GridCell span={4}>
          <Flex justifyContent='flex-start' margin='8px 0 0 0'>
            <Text>
              {intl.formatMessage({
                id: 'Load.Task.ConditionsGroupAndFilterLabelInclude'
              })}
            </Text>
          </Flex>
        </GridCell>
        <GridCell span={8}>
          <Flex display='block' justifyContent='flex-start' width='100%'>
            <Select
              data-mu-test='campaign__step-3__select-include-groups'
              searchable
              multiple
              placeholder={intl.formatMessage({
                id: 'Load.MailupCommon.SelectOneOrMoreGroups'
              })}
              variant={SELECT_VARIANT_WITH_CHECKBOX}
              onChange={handleChange}
              onSearch={handleSearch}
              options={withNoGroup}
              value={EmailOptions.IncludeGroups || []}
              {...props}
            />
          </Flex>
        </GridCell>
      </Grid>
    </>
  )
}

export default IncludeGroups
